import React, { useEffect, useState } from 'react'
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import { ApiServicePublicServerless } from '../xhr_libs';
import Loader from '../components/Loader';
import LoginPageDecoration from '../components/LoginPageDecoration';

const PAGE_TITLE = 'Plug Download';


export default function PlugDownloadPublic(props) {
  const {
    match: {
      params: { statementId, accountId },
    },
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [downloadState, setDownloadState] = useState(0);

  useEffect(() => {
    if (statementId && accountId) {
      handleDownload(statementId, accountId)
    }
  }, [statementId, accountId])

  const handleDownload = (statementId, accountId) => {
    setIsLoading(true)
    ApiServicePublicServerless.get(
      `/plug/get_url/${statementId}/${accountId}/download`
    ).then((res) => {
      const old_link = document.getElementById('public-bill-download-link');
      if (old_link) {
        old_link.remove();
      }
      const link = document.createElement('a');
      link.href = res.data;
      link.id = 'public-bill-download-link';
      link.target = '_blank';
      link.setAttribute('download', `${statementId}.pdf`);
      document.body.appendChild(link);
      link.click();
      setDownloadState(1);
    })
      .catch(() => {
        setDownloadState(2);
      })
      .finally(() => {
        setIsLoading(false)
      })

  }

  return <>
    <LoginPageDecoration />
    <Container style={{ 'textAlign': 'center', 'marginTop': '50px' }}>
      <Helmet>
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <>{isLoading && <Loader />}</>
      <>{downloadState === 2 && <>There was an issue downloading the requested bill. An attempt will be made to email a copy of the bill to you. If you do not receive it, please reach out to an administrator.</>}</>
      <>{downloadState === 1 && <>  Bill downloaded successfully.</>}</>
      <div>
        <Button as={Link} to='/' variant='primary' style={{ marginTop: '30px' }}>
          Take Me Home
        </Button>
      </div>
    </Container>

  </>
}